import { createFileRoute, redirect } from "@tanstack/react-router";

// 文档生成已并入工作台「文档生成」展开层；本路由保留为深链兼容
export const Route = createFileRoute("/_app/doc-generation/")({
  beforeLoad: () => {
    throw redirect({
      to: "/workbench",
      search: { view: "docgen" },
      replace: true,
    });
  },
});
